import {
  FieldCategoryRow,
  FieldRow,
  FieldValue,
  FieldViewValue,
} from '@/components/layout/field-row'
import { Building } from '@/reducers/types'

import { PlaceFeatureKey } from '../../features/places-features.constants'
import { usePlaceFeatureControl } from './use-place-feature-control'
import { usePlaceFeatureTooltip } from './use-place-feature-tooltip'

interface PlaceFeatureRowProps {
  building: Building
  customLabel?: string
  depth?: number
  error?: string
  featureKey: PlaceFeatureKey
  isAdmin: boolean
  isEditing: boolean
  // Note: `category` is the compact multi-column row, `field` is the full-width "label | value" row
  layout?: 'category' | 'field'
}

export const PlaceFeatureRow = ({
  building,
  customLabel,
  depth = 0,
  error,
  featureKey,
  isAdmin,
  isEditing,
  layout = 'category',
}: PlaceFeatureRowProps) => {
  const feature = usePlaceFeatureControl({
    building,
    customLabel,
    error,
    featureKey,
    isAdmin,
    isEditing,
  })

  const tooltip = usePlaceFeatureTooltip(featureKey, feature?.hint)

  if (!feature) return null

  const { control, controlWithReason, hint, label } = feature

  if (layout === 'field') {
    return (
      <FieldRow hint={hint} label={label}>
        {isEditing ? (
          <FieldValue>
            {controlWithReason}
            {error && <span>{error}</span>}
          </FieldValue>
        ) : (
          <FieldViewValue>{control}</FieldViewValue>
        )}
      </FieldRow>
    )
  }

  return (
    <FieldCategoryRow depth={depth} error={error} hint={tooltip} label={label}>
      {controlWithReason}
    </FieldCategoryRow>
  )
}
